export default __webpack_public_path__ + "static/media/FIU_SCIS.e104b4f3.svg";